import { BaseModel } from "../base.model";

export class RefWorkPlan extends BaseModel {
  name: string;
  id: number;
}
